import React, { useState, useEffect } from "react";
import { Add, Clear, Search } from "@mui/icons-material"
import { useNavigate } from 'react-router-dom';
import {
    Alert, Box, Button, Modal, Snackbar, TextField,
    Paper, Typography, Avatar, Chip, Divider, CircularProgress, Fade, Zoom
} from "@mui/material"
import Select from 'react-select';
import { allcampuses } from "../Utils/arrays";
import axios from "axios";
import { getsessionuser } from "../Utils/sessions";
import Postblog from "./postblog";
import SignIn from "../Common/login";
import { Fetchblogsurl } from "../Utils/urls";
import { convertToHTML } from 'draft-convert';
import { convertFromRaw } from "draft-js";
import { blogminutes, createMarkup } from "../Utils/functions";
import { imageplaceholder } from "../Utils/defaults";
import Shuffle from "../Utils/shuffle";
import { FaPen, FaRegClock, FaRegEye } from "react-icons/fa";

const BRAND = '#900f20';
const BRAND_DARK = '#670600';

const formatDate = (str) => {
    if (!str) return '';
    const d = new Date(str);
    return isNaN(d) ? str : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

const selectStyles = {
    control: (base, state) => ({
        ...base, borderRadius: 12,
        border: `1px solid ${state.isFocused ? BRAND : '#e0e0e0'}`,
        boxShadow: state.isFocused ? `0 0 0 2px rgba(144,15,32,0.1)` : 'none',
        '&:hover': { borderColor: BRAND }, minHeight: 44, fontSize: 14,
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? BRAND : state.isFocused ? 'rgba(144,15,32,0.05)' : 'white',
        color: state.isSelected ? 'white' : '#2d3436',
        fontWeight: state.isSelected ? 700 : 400
    }),
    indicatorSeparator: () => ({ display: 'none' }),
};




const Fetchblogs = ({ onrefresh }) => {
    const navigate = useNavigate()
    const user = getsessionuser()
    const [hint, sethint] = useState('');

    //filters
    const [campusfilter, setcampusfilter] = useState('chuka');

    //searchbar
    const [showClearIcon, setShowClearIcon] = useState('none');

    const [allblogs, setallblogs] = useState([]);
    const [displayedblogs, setdisplayedblogs] = useState([]);


    const [progress, setprogress] = useState(false);
    const [error, seterror] = useState('');


    const [showaddview, setshowaddview] = useState(false);
    const [showlogin, setshowlogin] = useState(false);






    useEffect(() => {
        search();
    }, []);


    //blogs
    //fetch blogs
    const search = async (e) => {
        setprogress(true)
        seterror(null)
        axios.post(Fetchblogsurl, {
            campus: campusfilter
        }).then(response => {
            setprogress(false)
            if (!response.data.error) {
                document.title = 'Eazistey Blogs'
                document.querySelector('meta[name="description"]').setAttribute('content', response.data?.map((val) => val.title).join(', '));

                setdisplayedblogs(Shuffle(response.data))
                setallblogs(Shuffle(response.data))
            } else {
                seterror(response.data.message)
            }
            // 
        }).catch(error => {
            setprogress(false)
            seterror("Sorry there was an error try again later")
        });
    }

    const Searchlogic = (text) => {
        var result = [];
        allblogs.forEach(element => {
            if (
                (text && element.username?.toLowerCase().replace(/\s+/g, '').match(text?.toLowerCase().replace(/\s+/g, '')) || element.title?.toLowerCase().replace(/\s+/g, '').match(text?.toLowerCase().replace(/\s+/g, '')))
                && element.campus?.toLowerCase().replace(/\s+/g, '').match(campusfilter?.toLowerCase().replace(/\s+/g, ''))
            ) {
                result.push(element)
            }
        });
        return result;
    }

    //search blogs
    const searchblogs = (text) => {
        if (!text) {
            setdisplayedblogs(allblogs)
        } else {
            const gottendata = Searchlogic(text)
            if (gottendata.length > 0) {
                setdisplayedblogs(gottendata)
            } else {
                setdisplayedblogs([])
                seterror("no articles match the search query")
            }
        }
    }





    const clearsearch = () => {
        setShowClearIcon("none")
        sethint()
        setdisplayedblogs(allblogs)
    }






    const handleChange = (event) => {
        setShowClearIcon(event.target.value === "" ? "none" : "flex");
        sethint(event.target.value)
        searchblogs(event.target.value)
    };




    //fund post blog functions
    const onsuccesspost = () => {//on successpost
        setshowaddview(false)
        search()

    }
    const onfailpost = () => {//on fail fund

    }
    const oncancelpost = () => {// in cancel fund modal
        setshowaddview(false)
        search()
    }


    //login view functions
    const onsuccesslogin = () => {
        setshowaddview(true)
        setshowlogin(false)
        onrefresh()
    }



    //launch add view
    const launchaddview = () => {
        if (user) {
            setshowaddview(true)
            // if (user.url) {
            //     setshowaddview(true)
            // } else {
            //     seterror("Upload your profile picture in order to publish a blog")
            // }
        } else {
            setshowlogin(true)
        }
    }



    // split for featured hero layout
    const featured = displayedblogs[0];
    const rest = displayedblogs.slice(1);

    return (
        <Box sx={{ bgcolor: '#f8f9fa', minHeight: '100vh', pb: 12, width: "90%", margin: "auto" }}>

            {/* Modals */}
            <Snackbar open={Boolean(error?.length > 0)} autoHideDuration={3000} onClose={() => seterror('')}>
                <Alert severity="error">{error}</Alert>
            </Snackbar>
            <Modal open={showlogin} onClose={() => setshowlogin(false)}>
                <SignIn onsuccesslogin={onsuccesslogin} />
            </Modal>
            <Modal open={showaddview} onClose={() => setshowaddview(false)}>
                <Postblog onsuccesspost={onsuccesspost} oncancelpost={oncancelpost} />
            </Modal>

            {/* ── Header ── */}
            <Box sx={{ px: { xs: 2, md: 4 }, pt: 4, pb: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, mb: 3 }}>
                    <Box>
                        <Typography variant="h4" sx={{ fontWeight: 800, color: '#1a1a1a', letterSpacing: '-0.5px', mb: 0.75 }}>
                            Eaziblog
                        </Typography>
                        <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: 480 }}>
                            Stories, tips and guides from students across campuses.
                        </Typography>
                    </Box>
                    <Button
                        onClick={launchaddview}
                        variant="contained" disableElevation
                        startIcon={<FaPen size={14} />}
                        sx={{
                            borderRadius: '14px', px: 3, py: 1.4, textTransform: 'none', fontWeight: 700,
                            background: `linear-gradient(90deg, ${BRAND} 0%, ${BRAND_DARK} 100%)`,
                            boxShadow: '0 4px 16px rgba(144,15,32,0.25)',
                            display: { xs: 'none', sm: 'inline-flex' },
                            '&:hover': { boxShadow: '0 6px 20px rgba(144,15,32,0.35)', transform: 'translateY(-1px)' },
                            transition: 'all 0.3s',
                        }}
                    >
                        Write a Post
                    </Button>
                </Box>

                {/* Search + campus filter */}
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                    <Paper elevation={0} sx={{
                        display: 'flex', alignItems: 'center', pl: 2, borderRadius: '16px',
                        bgcolor: 'white', boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
                        border: '1px solid rgba(0,0,0,0.05)', flex: '1 1 260px', maxWidth: 460, height: 50,
                    }}>
                        <Search sx={{ color: 'text.disabled', mr: 1, flexShrink: 0 }} />
                        <TextField
                            fullWidth placeholder="Search articles or authors..."
                            variant="standard" InputProps={{ disableUnderline: true }}
                            value={hint} onChange={handleChange}
                        />
                        {hint && (
                            <Box onClick={clearsearch} sx={{ pr: 1.5, cursor: 'pointer', color: 'text.disabled', display: 'flex' }}>
                                <Clear fontSize="small" />
                            </Box>
                        )}
                    </Paper>
                    <Box sx={{ minWidth: 220, flex: '0 0 220px' }}>
                        <Select
                            styles={selectStyles}
                            options={allcampuses}
                            placeholder="Filter by campus..."
                            onChange={e => setcampusfilter(e.value)}
                        />
                    </Box>
                </Box>

                {!progress && (
                    <Typography variant="caption" sx={{ color: 'text.disabled', fontWeight: 600, mt: 2, display: 'block' }}>
                        {displayedblogs.length} {displayedblogs.length === 1 ? 'article' : 'articles'}
                        {hint ? ` matching "${hint}"` : ' available'}
                    </Typography>
                )}
            </Box>

            {/* ── Content ── */}
            <Box sx={{ px: { xs: 2, md: 4 } }}>

                {/* Loading skeletons */}
                {progress && (
                    <Box>
                        <Paper elevation={0} sx={{ borderRadius: '24px', height: { xs: 300, md: 300 }, mb: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'rgba(0,0,0,0.02)' }}>
                            <CircularProgress size={30} sx={{ color: BRAND }} />
                        </Paper>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '2%' }}>
                            {[...Array(6)].map((_, i) => (
                                <Paper key={i} elevation={0} sx={{ width: { xs: '100%', sm: '48%', lg: '31%' }, height: 320, borderRadius: '20px', mb: 3, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'rgba(0,0,0,0.02)' }}>
                                    <CircularProgress size={24} sx={{ color: BRAND }} />
                                </Paper>
                            ))}
                        </Box>
                    </Box>
                )}

                {/* Featured card — first blog */}
                {!progress && featured && (() => {
                    const htmltext = convertToHTML(convertFromRaw(JSON.parse(featured.content)));
                    return (
                        <Fade in timeout={500}>
                            <Paper
                                elevation={0}
                                onClick={() => navigate(`/nav/viewsingleblog/${featured.id}`)}
                                sx={{
                                    borderRadius: '24px', overflow: 'hidden', cursor: 'pointer',
                                    border: '1px solid rgba(0,0,0,0.04)', bgcolor: 'white', mb: 4,
                                    display: 'flex', flexDirection: { xs: 'column', md: 'row' },
                                    minHeight: { md: 300 },
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                                    transition: 'all 0.4s ease',
                                    '&:hover': { boxShadow: '0 20px 48px rgba(0,0,0,0.09)', transform: 'translateY(-5px)' }
                                }}
                            >
                                <Box sx={{ flex: '0 0 44%', overflow: 'hidden', position: 'relative', minHeight: { xs: 220, md: 'auto' } }}>
                                    <Box component="img" src={featured.blogurl || imageplaceholder} alt={featured.title}
                                        sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', transition: 'transform 0.6s', '&:hover': { transform: 'scale(1.04)' } }}
                                    />
                                    <Chip label="✦ Featured" size="small"
                                        sx={{ position: 'absolute', top: 14, left: 14, bgcolor: BRAND, color: 'white', fontWeight: 700, fontSize: '0.75rem', boxShadow: '0 4px 12px rgba(144,15,32,0.3)' }}
                                    />
                                </Box>
                                <Box sx={{ flex: 1, p: { xs: 3, md: 4 }, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2.5 }}>
                                        <Avatar src={featured.profile_url || imageplaceholder} sx={{ width: 40, height: 40, border: `2px solid rgba(144,15,32,0.12)` }}>
                                            {featured?.username?.charAt(0)?.toUpperCase()}
                                        </Avatar>
                                        <Box>
                                            <Typography variant="body2" sx={{ fontWeight: 700, color: '#1a1a1a', lineHeight: 1.2 }}>{featured?.username}</Typography>
                                            <Typography variant="caption" sx={{ color: 'text.disabled' }}>{formatDate(featured.dateposted)}</Typography>
                                        </Box>
                                    </Box>
                                    <Typography variant="h5" sx={{ fontWeight: 800, color: '#1a1a1a', mb: 1.5, lineHeight: 1.35, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                        {featured.title}
                                    </Typography>
                                    <Box sx={{ color: 'text.secondary', fontSize: '0.9rem', lineHeight: 1.7, display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden', flexGrow: 1 }}
                                        dangerouslySetInnerHTML={createMarkup(htmltext)}
                                    />
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 3, pt: 2, borderTop: '1px solid rgba(0,0,0,0.05)' }}>
                                        <Box sx={{ display: 'flex', gap: 2 }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6, color: 'text.disabled' }}>
                                                <FaRegClock size={13} />
                                                <Typography variant="caption" sx={{ fontWeight: 600 }}>{blogminutes(htmltext)} min read</Typography>
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6, color: 'text.disabled' }}>
                                                <FaRegEye size={13} />
                                                <Typography variant="caption" sx={{ fontWeight: 600 }}>{featured.clicks || 0} views</Typography>
                                            </Box>
                                        </Box>
                                        <Typography variant="caption" sx={{ color: BRAND, fontWeight: 700 }}>Read Article →</Typography>
                                    </Box>
                                </Box>
                            </Paper>
                        </Fade>
                    );
                })()}

                {/* Section divider */}
                {!progress && rest.length > 0 && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                        <Typography variant="h6" sx={{ fontWeight: 800, color: '#1a1a1a', whiteSpace: 'nowrap' }}>More Articles</Typography>
                        <Divider sx={{ flex: 1 }} />
                    </Box>
                )}

                {/* Blog grid */}
                {!progress && rest.length > 0 && (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: { xs: 2, sm: '2%' } }}>
                        {rest.map((val, key) => {
                            const htmltext = convertToHTML(convertFromRaw(JSON.parse(val.content)));
                            return (
                                <Fade key={key} in timeout={400}>
                                    <Paper
                                        elevation={0}
                                        onClick={() => navigate(`/nav/viewsingleblog/${val.id}`)}
                                        sx={{
                                            width: { xs: '100%', sm: '48%', lg: '31%' }, mb: 3,
                                            borderRadius: '20px', overflow: 'hidden', cursor: 'pointer',
                                            border: '1px solid rgba(0,0,0,0.04)', bgcolor: 'white',
                                            display: 'flex', flexDirection: 'column',
                                            boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                                            transition: 'all 0.4s cubic-bezier(0.175,0.885,0.32,1.275)',
                                            '&:hover': { boxShadow: '0 20px 40px rgba(0,0,0,0.08)', transform: 'translateY(-7px)' }
                                        }}
                                    >
                                        {/* Cover */}
                                        <Box sx={{ height: 190, overflow: 'hidden' }}>
                                            <Box component="img" src={val.blogurl || imageplaceholder} alt={val.title}
                                                sx={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s', '&:hover': { transform: 'scale(1.05)' } }}
                                            />
                                        </Box>
                                        {/* Body */}
                                        <Box sx={{ p: 2.5, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                                            {/* Author */}
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, mb: 1.5 }}>
                                                <Avatar src={val.profile_url || imageplaceholder} sx={{ width: 30, height: 30, fontSize: '0.8rem' }}>
                                                    {val?.username?.charAt(0)?.toUpperCase()}
                                                </Avatar>
                                                <Box>
                                                    <Typography variant="caption" sx={{ fontWeight: 700, color: '#1a1a1a', display: 'block', lineHeight: 1.2 }}>{val?.username}</Typography>
                                                    <Typography variant="caption" sx={{ color: 'text.disabled', fontSize: '0.7rem' }}>{formatDate(val.dateposted)}</Typography>
                                                </Box>
                                            </Box>
                                            {/* Title */}
                                            <Typography variant="subtitle1" sx={{ fontWeight: 800, color: '#1a1a1a', mb: 1, lineHeight: 1.4, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                                {val.title}
                                            </Typography>
                                            {/* Preview */}
                                            <Box sx={{ color: 'text.secondary', fontSize: '0.84rem', lineHeight: 1.6, flexGrow: 1, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', mb: 2 }}
                                                dangerouslySetInnerHTML={createMarkup(htmltext)}
                                            />
                                            {/* Footer */}
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pt: 1.5, borderTop: '1px solid rgba(0,0,0,0.05)' }}>
                                                <Box sx={{ display: 'flex', gap: 1.5 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'text.disabled' }}>
                                                        <FaRegClock size={11} />
                                                        <Typography variant="caption" sx={{ fontSize: '0.71rem', fontWeight: 600 }}>{blogminutes(htmltext)} min</Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'text.disabled' }}>
                                                        <FaRegEye size={11} />
                                                        <Typography variant="caption" sx={{ fontSize: '0.71rem', fontWeight: 600 }}>{val.clicks || 0}</Typography>
                                                    </Box>
                                                </Box>
                                                <Typography variant="caption" sx={{ color: BRAND, fontWeight: 700, fontSize: '0.75rem' }}>Read →</Typography>
                                            </Box>
                                        </Box>
                                    </Paper>
                                </Fade>
                            );
                        })}
                    </Box>
                )}

                {/* Empty state */}
                {!progress && displayedblogs.length === 0 && (
                    <Box sx={{ textAlign: 'center', py: 10 }}>
                        <Typography sx={{ fontSize: 52, mb: 2 }}>📝</Typography>
                        <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>No articles yet</Typography>
                        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>Be the first to share something with the community.</Typography>
                        <Button onClick={launchaddview} variant="contained" disableElevation
                            sx={{ borderRadius: '14px', px: 4, py: 1.4, textTransform: 'none', fontWeight: 700, background: `linear-gradient(90deg, ${BRAND} 0%, ${BRAND_DARK} 100%)` }}>
                            Write the First Post
                        </Button>
                    </Box>
                )}
            </Box>

            {/* Floating write FAB (mobile) */}
            <Zoom in style={{ transitionDelay: '300ms' }}>
                <Box
                    onClick={launchaddview}
                    sx={{
                        display: { xs: 'flex', sm: 'none' },
                        position: 'fixed', bottom: 30, right: 22,
                        width: 54, height: 54, borderRadius: '50%',
                        bgcolor: BRAND, color: 'white',
                        alignItems: 'center', justifyContent: 'center',
                        boxShadow: '0 8px 28px rgba(144,15,32,0.4)',
                        cursor: 'pointer', zIndex: 1000,
                        transition: 'all 0.3s',
                        '&:hover': { bgcolor: BRAND_DARK, transform: 'scale(1.08)' }
                    }}
                >
                    <FaPen size={19} />
                </Box>
            </Zoom>
        </Box>
    )
}

export default Fetchblogs